'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function setup(instance, jqSlideshow) {
        jqSlideshow.slick({
            dots: true,
            arrows: true,
            appendArrows: $('[data-binding="gallery-nav"]'),
            appendDots: $('[data-binding="gallery-image-list"]'),
            prevArrow: '<button class="prev"></button>',
            nextArrow: '<button class="next"></button>'
        });
    }

    function init() {
        context.each(function () {
            if (context.closest('.section-content').css('display') !== 'none') {
                var instance = $(this);
                var instanceSlide = instance.find('[data-binding="gallery-image-list"]');

                setup(instance, instanceSlide);
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/gallery.js
// module id = 263
// module chunks = 0